<template>
    <div>
        <div v-if="!currentForm" class="alert alert-warning" role="alert">
            Este seguro no está disponible en esta versión.
        </div>
        <component :is="currentForm" v-if="currentForm" />
        <div v-if="guardadoError" class="alert alert-danger mt-3 no-print" role="alert">{{ guardadoError }}</div>
        <div v-if="currentForm" class="row mt-4 no-print">
            <div class="col-md-12 d-flex justify-content-end">
                <button class="btn btn-success btn-lg" :disabled="guardando || store.derechoPolizaEstado !== 'ok'"
                    @click="confirmarYTramitar">
                    <vue-feather type="check-circle" size="16" class="me-1"></vue-feather>
                    Confirmar y tramitar
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/axios';
import { useSeguroStore } from '@/stores/seguroStore';
import { buildCotizacionSnapshot, buildCondicionesDto } from '@/utils/cotizacionSnapshot';
import getField from '@/utils/getField';
import { familiaPorRamoId, FAMILIA_GMM, FAMILIA_VIDA } from '@/utils/familiaSeguro';
import FormularioGMM from './productos/FormularioGMM.vue';
import FormularioVida from './productos/FormularioVida.vue';

// El formulario depende de la familia del seguro (según su ramo), no del producto.
const FORM_POR_FAMILIA = {
    [FAMILIA_GMM]: FormularioGMM,
    [FAMILIA_VIDA]: FormularioVida,
};

export default {
    name: 'formularioPolizas',
    emits: ['nextTab'],
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            guardando: false,
            guardadoError: null,
        };
    },
    computed: {
        currentForm() {
            return FORM_POR_FAMILIA[familiaPorRamoId(this.store.ramoId)] ?? null;
        },
    },
    methods: {
        async confirmarYTramitar() {
            if (!this.currentForm || this.store.derechoPolizaEstado !== 'ok') return;

            // Construir snapshot para la vista de orden de trabajo
            this.store.cotizacionSnapshot = buildCotizacionSnapshot(this.store);

            // Construir y enviar condiciones al endpoint wizard
            const condiciones = buildCondicionesDto(this.store);
            const payload = {
                ...this.store.buildWizardDto(5),
                condiciones,
            };

            this.guardadoError = null;
            if (this.store.polizaId) {
                try {
                    this.guardando = true;
                    const response = await api.put(`wizard/poliza/${this.store.polizaId}`, payload);
                    const data = response.data || {};
                    this.store.polizaVersionId = getField(data, 'polizaVersionId') ?? this.store.polizaVersionId;
                    this.store.etapaWizard = 5;
                } catch (err) {
                    // Si el guardado falla el wizard se queda en este paso con los datos capturados.
                    this.guardadoError = this.mensajeDeError(err);
                    return;
                } finally {
                    this.guardando = false;
                }
            }

            this.$emit('nextTab');
        },
        // 422 del backend (derecho de póliza distinto al del año, año sin monto, asegurado único en Vida):
        // ver specs/006-actualizar-wizard-polizas/contracts/derechos-poliza-consumo.md
        mensajeDeError(err) {
            const respuesta = err?.response;
            if (respuesta?.status === 422 && respuesta.data?.detail) {
                const vigente = respuesta.data.derechoPolizaVigente;
                if (vigente != null) {
                    this.store.derechoPoliza = vigente;
                    // el detalle del backend ya termina en punto: se quita para no duplicarlo
                    return `${String(respuesta.data.detail).replace(/\.+$/, '')}. Se actualizó el monto; revise la cotización y confirme de nuevo.`;
                }
                return respuesta.data.detail;
            }
            return respuesta?.data?.message
                || respuesta?.data?.detail
                || 'No se pudieron guardar las condiciones de cotización.';
        },
    },
};
</script>
